import { ENDPOINT } from "../../constants/endpoint.js";
import {  API_BASE_URL_RTS } from "../../constants/index.js";
import _ from "lodash";
import moment from "moment";
import axios from "axios";

const state = {
  oilDistributions: [],
  loading: false,
  error: {},
  vesselTracking: [],
  vessels: [],
  countries: []
};

const mutations = {
  SET_PETROL_VESSEL_TRIP: (state, payload) => {
    state.oilDistributions = payload;
  },
  SET_PETROL_VESSELS: (state, payload) => {
    state.vessels = payload;
  },
  SET_PETROL_COUNTRIES: (state, payload) => {
    state.countries = payload;
  },
  LOADING(state, payload) {
    state.loading = payload.loading;
  },
  ERROR(state, payload) {
    state.error = { ...payload };
  },
};

const actions = {
  async getVesselTrip( context , data){
    context.commit("LOADING", { loading: true });
    const url = ENDPOINT.VESSEL_TRIPS;

    let params
    if (data.startDate && data.endDate) {
      params = {
        "q[workflow_state_cont]": "approved",
        "q[station_id_eq]": data.stationId,
        "q[departed_at_gteq]": data.startDate,
        "q[departed_at_lt]": data.endDate,
        "q[vessel_loads_destination_type_eq]": data.destinationType,
        domestic: data.domestic,
        "q[vessel_loads_serial_number_cont]": data.serialNumber,
        "q[trip_number_cont]": data.tripNumber,
        "q[vessel_loads_oil_type_id_eq]": data.oilTypeId,
        "q[vessel_id_eq]": data.vesselId,
      }
    } else {
      params = {
        limit: 100,
        "q[workflow_state_cont]": "approved",
        "q[vessel_loads_destination_type_eq]": data.destinationType,
        domestic: data.domestic,
      }
      
    }
    let config = {
      params
    };

    await axios
      .get(url, config)
      .then((res) => {
        context.commit("SET_PETROL_VESSEL_TRIP", res.data);
      })
      .catch((e) => {
        context.commit("ERROR", { error: e });
      })
      .finally(() => {
        context.commit("LOADING", { loading: false });
      });
  },
  async getVessels(context, data) {
    const config = {
      params: {
        "q[name_th_cont]": data,
        limit: 100
      },
    };
    const url = ENDPOINT.PETROL_GET_VESSELS;
    await axios
      .get(url, config)
      .then((res) => {
        context.commit("SET_PETROL_VESSELS", res.data);
      })
      .catch((e) => {
        context.commit("ERROR", { error: e });
      })
      .finally(() => {
        context.commit("LOADING", { loading: false });
      });
  },
  async getCountries( context){
    context.commit("LOADING", { loading: true });
    const url = ENDPOINT.PETROL_COUNTRIES;

    await axios
      .get(url)
      .then((res) => {
        context.commit("SET_PETROL_COUNTRIES", res.data);
      })
      .catch((e) => {
        context.commit("ERROR", { error: e });
      })
      .finally(() => {
        context.commit("LOADING", { loading: false });
      });
  },
  async getVesselsByMmsi(context, data) {
    const config = {
      params: {
        "q[mmsi_eq]": data.mmsi,
      },
    };
    const url = ENDPOINT.PETROL_GET_VESSELS;
    await axios
      .get(url, config)
      .then((res) => {
        context.commit("SET_PETROL_VESSELS", res.data);
      })
      .catch((e) => {
        context.commit("ERROR", { error: e });
      })
      .finally(() => {
        context.commit("LOADING", { loading: false });
      });
  },
  async clearVesselTrip(context) {
    context.commit("SET_PETROL_VESSEL_TRIP", []);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
